<template>
  <v-app id="onEign" >

    <defNavBar title="Ares - Host" :actions="eign.action_items" :accolist="true" :home="true" :attms="eign.attm_aant"
      :notts="eign.nott_aant" @actionClick="actionClick" />

    <v-main >
      <v-container fluid >
        <v-row v-if="eign.lHasAccess">
          <!-- Links -->
          <v-col cols="6" class="px-1">
            <v-container>
              <v-row>
                <v-col cols="12" class="px-1">
                  <!-- Host -->
                  <v-card>
                    <v-container>
                      <v-form ref="eignCard1" v-model="eignCard1Valid">
                        <v-card-title> Host {{ eign.eign_code }} </v-card-title>
                        <div class="ml-3">
                          <v-row no-gutters>
                            <v-col cols="7" class="px-1">
                              <v-text-field v-model="eign.eign_bedrijfsnaam" label="Company name" dense></v-text-field>
                            </v-col>
                            <v-col cols="3" offset="1" class="px-1">
                              <span v-if="eign.eign_channel_managers !== ''">
                                <v-text-field v-model="eign.eign_channel_managers" readonly
                                  label="Uses channel manager(s)" dense></v-text-field>
                              </span>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="5" class="px-1">
                              <v-text-field v-model="eign.eign_naam" :rules="eign_naamRules" label="Last name"
                                dense></v-text-field>
                            </v-col>
                            <v-col cols="2">
                              <v-menu v-model="dat1menu" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="eign.eign_geb_dat" label="Date of birth" v-on="on"
                                    dense></v-text-field>
                                </template>
                                <v-date-picker v-model="eign.eign_geb_dat2" :first-day-of-week="1"
                                  @input="eign.eign_geb_dat = $moment(eign.eign_geb_dat2).format('DD-MM-YYYY'); dat1menu = false;"></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="4"></v-col>
                            <v-col cols="1">
                              <btn_audit table="eign" :encrid="eign.eign_encrid" :size=30 tooltip="audit of host" />
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <!-- <v-col cols="2" class="px-1">
                                                                <v-select v-model="eign.aanh_code" :items="aanh_codeKeuzes" item-value="aanh_code" item-text="aanhtaal_oms" label="Title" dense></v-select>
                                                            </v-col> -->
                            <v-col cols="7" class="px-1">
                              <v-text-field v-model="eign.eign_voornaam" label="First name" dense></v-text-field>
                            </v-col>
                            <v-col cols="2" class="px-1">

                            </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="2" class="px-1">
                              <v-select v-model="eign.taal_code" :items="taal_codeKeuzes" label="Language"
                                dense></v-select>
                            </v-col>
                            <v-col cols="5" class="px-1">
                              <v-select v-model="taal_code2" :items="taal_code2Keuzes" item-value="taal_code"
                                item-text="taaltaal_oms" multiple label="Other Languages" dense></v-select>
                            </v-col>
                          </v-row>
                          <!-- <v-row no-gutters>
                            <v-col cols="7" class="px-1">
                              <v-text-field v-model="eign.eign_adres" label="Address Street / Housenumber"
                                dense></v-text-field>
                            </v-col>
                          </v-row> -->
                         <v-row no-gutters>
                            <v-col cols="7" class="px-1">
                              <v-text-field v-model="eign.eign_adres" label="Address" ref="autocomplete"
                                placeholder="" autocomplete="new-password" dense></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="2" class="px-1">
                              <v-text-field v-model="eign.eign_postcode" label="Postcal code" dense autocomplete="x-password"></v-text-field>
                            </v-col>
                            <v-col cols="5" class="px-1">
                              <v-text-field v-model="eign.eign_plaats" label="City" dense autocomplete="y-password"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="4" class="px-1">
                              <v-select v-model="eign.land_code" :items="land_codeKeuzes" item-value="land_code"
                                item-text="landtaal_oms" label="Country" dense></v-select>
                            </v-col>
                          </v-row>
                          <div style="display: flex; flex-direction: row; margin-bottom: 10px">
                            <div style="display: flex; flex-direction: row; align-items: center;">
                              <div class="px-1" style="width: 220px;">
                                <v-text-field v-model="eign.eign_latitude" label="GPS Latitude" dense></v-text-field>
                              </div>
                              <div class="px-1" style="width: 220px;">
                                <v-text-field v-model="eign.eign_longitude" label="GPS Longitude" dense></v-text-field>
                              </div>
                            </div>
                            <div>
                              <div style="display: flex; flex-direction: row; align-items:flex-start;">
                                <v-icon color="blue">mdi-information-outline</v-icon>
                                <div style="font-size: 8pt; margin-left: 5px; padding-right: 15px;">Latitude and
                                  longitude are used when key
                                  pickup is "House of the host" or "At the reception". Both are printed on guest
                                  documents if they have valid
                                  values.</div>
                              </div>
                            </div>
                          </div>
                          <v-row no-gutters>
                            <v-col cols="2" class="px-1">
                              <v-text-field v-model="eign.eign_tel1_vcs" label="Tel 1 Number" dense></v-text-field>
                            </v-col>
                            <v-col cols="2" class="px-1">
                              <v-text-field v-model="eign.eign_tel1_type" label="Tel 1 Type" dense></v-text-field>
                            </v-col>
                            <v-col cols="3" class="px-1">
                              <v-checkbox v-model="eign.eign_tel1_approved" readonly label="Numverify Approved"
                                dense></v-checkbox>
                            </v-col>
                            <v-col cols="2" class="px-1">
                              <v-checkbox v-model="eign.eign_tel1_whatsapp" label="Whatsapp"
                                dense :disabled="eign.eign_tel1_type !== 'mobile'"></v-checkbox>
                            </v-col>
                            <v-col cols="3" class="px-1">
                              <v-text-field v-model="eign.eign_tel1_oms" label="Remark" placeholder="."
                                dense></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="2" class="px-1">
                              <v-text-field v-model="eign.eign_tel2_vcs" label="Tel 2 Number" dense></v-text-field>
                            </v-col>
                            <v-col cols="2" class="px-1">
                              <v-text-field v-model="eign.eign_tel2_type" label="Tel 2 Type" dense></v-text-field>
                            </v-col>
                            <v-col cols="3" class="px-1">
                              <v-checkbox v-model="eign.eign_tel2_approved" readonly label="Numverify Approved"
                                dense></v-checkbox>
                            </v-col>
                            <v-col cols="2" class="px-1">
                              <v-checkbox v-model="eign.eign_tel2_whatsapp" label="Whatsapp"
                                dense :disabled="eign.eign_tel2_type !== 'mobile'"></v-checkbox>
                            </v-col>

                            <v-col cols="3" class="px-1">
                              <v-text-field v-model="eign.eign_tel2_oms" label="Remark" placeholder="."
                                dense></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="2" class="px-1">
                              <v-text-field v-model="eign.eign_tel3_vcs" label="Tel 3 Number" dense></v-text-field>
                            </v-col>
                            <v-col cols="2" class="px-1">
                              <v-text-field v-model="eign.eign_tel3_type" label="Tel 3 Type" dense></v-text-field>
                            </v-col>
                            <v-col cols="3" class="px-1">
                              <v-checkbox v-model="eign.eign_tel3_approved" readonly label="Numverify Approved"
                                dense></v-checkbox>
                            </v-col>
                            <v-col cols="2" class="px-1">
                              <v-checkbox v-model="eign.eign_tel3_whatsapp" label="Whatsapp"
                                dense :disabled="eign.eign_tel3_type !== 'mobile'"></v-checkbox>
                            </v-col>

                            <v-col cols="3" class="px-1">
                              <v-text-field v-model="eign.eign_tel3_oms" label="Remark" placeholder="."
                                dense></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="11" class="px-1">
                              <v-text-field v-model="eign.eign_email" label="Email" dense></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="11" class="px-1">
                              <v-text-field v-model="eign.eign_email_extra" label="Email extra addresses"
                                dense></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="11" class="px-1">
                              <v-text-field v-model="eign.eign_www" label="Website" dense></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="4" class="px-1">
                              <v-checkbox v-model="eign.eign_newsletter" label="Host Newsletter" dense></v-checkbox>
                            </v-col>
                            <v-col cols="3" class="px-1">
                              <v-text-field v-if="eign.eign_inschrijf_dt > ''" v-model="eign.eign_inschrijf_dt"
                                label="Opt-IN" readonly dense></v-text-field>
                            </v-col>
                            <v-col cols="3" class="px-1">
                              <v-text-field v-if="eign.eign_uitschrijf_dt > ''" v-model="eign.eign_uitschrijf_dt"
                                label="Opt-OUT" readonly dense></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="4" class="px-1">
                              <v-checkbox v-model="eign.eign_klnt_newsletter" label="Guest Newsletter"
                                dense></v-checkbox>
                            </v-col>
                            <v-col cols="3" class="px-1">
                              <v-text-field v-if="eign.eign_klnt_inschrijf_dt > ''"
                                v-model="eign.eign_klnt_inschrijf_dt" label="Opt-IN" readonly dense></v-text-field>
                            </v-col>
                            <v-col cols="3" class="px-1">
                              <v-text-field v-if="eign.eign_klnt_uitschrijf_dt > ''"
                                v-model="eign.eign_klnt_uitschrijf_dt" label="Opt-OUT" readonly dense></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row no-gutters class="mt-2">
                            <v-col cols="1">
                              <v-btn class="primary" :disabled="!eignCard1Valid" small
                                @click="saveEignCard1">Save</v-btn>
                            </v-col>
                          </v-row>
                        </div>
                      </v-form>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
              <!-- complaints -->
              <v-row>
                <v-col cols="12" class="px-1">
                  <eign_hokl :eign_encrid="eign_encrid" />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <!-- Rechts  -->
          <v-col cols="6" class="px-1">
            <v-container>
              <!-- Relation -->
              <v-row v-if="eign.turnover.length !== 0">
                <v-col cols="12" class="px-1">
                  <v-card>
                    <v-card-text>
                      <YearTurnover :turnover="eign.turnover" />
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                    <v-container>
                      <div style="display: flex; flex-direction: row">
                        <v-form ref="eignCard3" v-model="eignCard3Valid">
                          <!-- <v-card-title>Relation</v-card-title> -->
                          <div
                            style="font-weight: 500; font-size: 16pt; margin-left: 16px; margin-bottom: 16px; margin-top: 12px;">
                            Relation</div>
                          <div style="cursor:default" class="ml-4">
                            <v-row no-gutters>
                              <v-col cols="8" class="pr-2">
                                <v-select v-model="eign.gebr_code" :items="gebr_codeKeuzes" item-value="gebr_code"
                                  item-text="gebr_naam" label="Contact" dense></v-select>
                              </v-col>
                              <v-col cols="1">
                                <btn_audit table="eign" :encrid="eign.eign_encrid" :size=30 tooltip="audit of host" />
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col cols="1" class="mt-2 mb-2">
                                <v-btn class="primary" :disabled="!eignCard3Valid" small
                                  @click="saveEignCard3">Save</v-btn>
                              </v-col>
                            </v-row>
                          </div>
                        </v-form>
                        <div>
                          <div style="font-weight: 500; font-size: 16pt; margin-bottom: 12px; margin-top: 12px;">Rental
                            experts
                          </div>
                          <ul>
                            <li v-for="expert in eign.rental_experts" :key="expert.code">
                              {{ expert.name }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
              <!-- Ambassador -->
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                    <v-container>
                      <v-form ref="eignCard3" v-model="eignCard3Valid">
                        <v-card-title>Ambassador</v-card-title>
                        <div style="cursor:default" class="ml-4">
                          <v-row no-gutters>
                            <v-col cols="3" class="pr-2">
                              <v-text-field ref="ambassador" v-model="eign.ambassador" label="Ambassador" readonly dense
                                @mousedown="selectAmbassador"></v-text-field>
                            </v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="3" class="pr-2">
                            </v-col>
                            <v-col cols="4"></v-col>
                            <v-col cols="1">
                              <btn_audit table="eign" :encrid="eign.eign_encrid" :size=30 tooltip="audit of host" />
                            </v-col>
                          </v-row>
                        </div>
                      </v-form>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
              <!-- Finance -->
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                    <v-container>
                      <v-form ref="eignCard2" v-model="eignCard2Valid">
                        <v-card-title>Finance</v-card-title>
                        <div style="cursor:default" class="ml-4">
                          <v-row no-gutters>
                            <v-col cols="4">
                              <v-text-field v-model="eign.eign_iban" label="Bank account IBAN" dense
                                :readonly="eign.eign_iban_readonly == 1" :hint=eign.eign_iban_hint></v-text-field>
                            </v-col>
                            <v-col cols="2" class="pl-4">
                              <v-text-field v-model="eign.eign_bic" label="BIC" dense
                                :readonly="eign.eign_iban_readonly == 1" :hint=eign.eign_bic></v-text-field>
                            </v-col>
                            <v-col cols="5" class="pl-4">
                              <v-text-field v-model="eign.eign_iban_naam"
                                label="Host name on bankaccount (only if different from name)" dense
                                :readonly="eign.eign_iban_readonly == 1" :hint=eign.eign_iban_hint></v-text-field>
                            </v-col>
                            <v-col cols="1">
                              <btn_audit table="eign" :encrid="eign.eign_encrid" :size=30 tooltip="audit of host" />
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="8">
                              <v-select v-model="eign.ebtc_code" :items="ebtc_codeKeuzes" item-value="ebtc_code"
                                item-text="ebtctaal_oms" label="Payment" dense></v-select>
                            </v-col>
                          </v-row>

                          <!-- <v-row no-gutters>
                            <v-col cols="3">
                              <v-select v-model="eign.eign_id_doc_type" :items="eign_id_doc_typeKeuzes"
                                item-value="code" item-text="desc" label="Identity document type" dense></v-select>
                            </v-col>
                            <v-col cols="4" class="px-2">
                              <v-text-field v-model="eign.eign_id_doc_code" label="Identity document number"
                                dense></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="3">
                              <v-select v-model="eign.land_code_nationaliteit" :items="eign.nat_codeKeuzes"
                                item-value="nat_code" item-text="nat_oms" label="Nationality" dense></v-select>
                            </v-col>
                            <v-col cols="3" class="px-2">
                              <v-select v-model="eign.eign_rechtsvorm" :items="eign.eign_rechtsvormKeuzes"
                                item-value="code" item-text="desc" label="Legal form" dense></v-select>
                            </v-col>
                            <v-col cols="4" class="px-2">
                              <v-text-field v-model="eign.eign_fiscaal_code" label="Fiscal ID" dense></v-text-field>
                            </v-col>
                          </v-row>
 -->
                          <v-row no-gutters>
                            <v-col cols="3">
                              <v-text-field v-model="eign.eign_kvk" label="Chamber of Commerce ID" dense></v-text-field>
                            </v-col>
                            <v-col cols="2" class="pl-4">
                              <v-select v-model="eign.eign_btw_num_stat" :items="eign_btw_num_statKeuzes"
                                item-value="code" item-text="desc" label="VAT applicable" dense></v-select>
                            </v-col>
                            <v-col cols="4" class="pl-4">
                              <v-text-field v-model="eign.eign_btw_num" label="VAT number" dense></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row no-gutters v-if="eign.eign_btw_num === ''">
                            <v-col cols="3">
                              <v-menu v-model="dat2menu" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field v-model="eign.eign_geb_dat" label="Date of birth" v-on="on"
                                    dense></v-text-field>
                                </template>
                                <v-date-picker v-model="eign.eign_geb_dat2" :first-day-of-week="1"
                                  @input="eign.eign_geb_dat = $moment(eign.eign_geb_dat2).format('DD-MM-YYYY'); dat2menu = false;"></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="3" class="pl-4">
                                <v-select v-model="eign.eign_land_code_geb" :items="land_codeKeuzes" item-value="land_code" item-text="landtaal_oms" label="Country of birth" dense></v-select>
                            </v-col>
                            <v-col cols="3" class="pl-4">
                              <v-text-field v-model="eign.eign_geb_plaats" label="Place of birth" dense></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="4">
                              <v-select v-model="eign.eign_sales_com" :items="eign_sales_comKeuzes" item-value="nr"
                                item-text="desc" menu-props="auto" label="Sales Commission percentage"
                                :readonly="eign.eign_sales_com_readonly == 1" :hint=eign.eign_sales_com_hint
                                dense></v-select>
                            </v-col>
                            <v-col cols="4" class="pl-4">
                              <v-checkbox v-model="eign.eign_bank_stop" :disabled="eign.eign_bank_stop_disabled"
                                label="Payment stop" dense></v-checkbox>
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="1">
                              <v-btn class="primary mt-2 mb-2" :disabled="!eignCard1Valid" small
                                @click="saveEignCard2">Save</v-btn>
                            </v-col>
                          </v-row>
                        </div>
                      </v-form>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
              <!-- MyVilla -->
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                    <v-container>
                      <v-form ref="EignCard4">
                        <v-card-title>MyVilla</v-card-title>
                        <div style="cursor:default" class="ml-4">
                          <v-row no-gutters>
                            <v-col cols="3">
                              <v-text-field v-model="eign.eign_login_dt" label="Last Login" readonly></v-text-field>
                            </v-col>
                            <v-col v-if="eign.eign_email > ''" cols="2" class="px-15">
                              <v-btn class="primary mt-3" small @click="loginInfo(eign.eign_encrid)">Login Host website
                                MyVilla</v-btn>
                            </v-col>
                            <v-col v-else cols="2" class="px-15"></v-col>
                          </v-row>
                          <v-row no-gutters v-if="!eign.eign_password">
                            <v-icon color="warning" class="mr-2">mdi-lock-off</v-icon>
                            <div class="pt-1">This host does not have a password set. Send an invite by mail to set a
                              password
                            </div>
                            <v-btn class="primary ml-4" small @click="sendInvite()">Send invite</v-btn>
                          </v-row>
                        </div>
                        <div class="pb-4 mt-5" v-if="eign.show_dev_options">
                          <div class="ml-4 mr-4" style="background-color: orange;  padding: 10px; border-radius: 5px;">
                            <div
                              style="display: flex; flex-direction: row; gap: 10px; align-items: center; margin-top: 5px;">
                              <v-btn class="primary" x-small
                                @click="loginInfoDev(eign.eign_encrid, 1)">localhost:3000</v-btn>
                              <v-btn class="primary" x-small
                                @click="loginInfoDev(eign.eign_encrid, 2)">mytestvilla.villaforyou.com</v-btn>
                            </div>
                          </div>
                        </div>
                      </v-form>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
              <!-- Damages -->
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                    <v-container>
                      <v-card-title>Damages<v-spacer></v-spacer>
                        <v-btn class="primary ma-2" x-small @click="showHosm(eign.eign_encrid)"
                          v-if="eign.numberOfClaims > 0">Details</v-btn>
                      </v-card-title>
                      <div style="cursor:default" class="ml-4">
                        <v-row no-gutters>
                          <v-col cols="12">Total number of damage claims {{ eign.numberOfClaims }}</v-col>
                        </v-row>
                        <v-row cols="12" no-gutter dense class="mt-5">
                          <v-col cols="3">
                            <v-text-field v-model.lazy="eign.claimed" readonly dense label="Claimed" prefix="€"
                              class="pt-1 text-field-style text-grey"></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field v-model.lazy="eign.insurer" readonly dense label="Insurer" prefix="€"
                              class="pt-1 pl-3 text-field-style text-grey"></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field v-model.lazy="eign.leniency" readonly dense label="Leniency" prefix="€"
                              class="pt-1 pl-3 text-field-style text-grey"></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field v-model.lazy="eign.in_house" readonly dense label="In House" prefix="€"
                              class="pt-1 pl-3 text-field-style text-grey"></v-text-field>
                          </v-col>
                        </v-row>
                      </div>
                      <span class="br_medium"></span>
                      <v-row><v-col></v-col></v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
              <!-- Pending rebookings on this house -->
              <v-row>
                <v-col cols="12" class="pa-1">
                  <countHomb :entity="'eign'" :encrid="eign_encrid" />
                </v-col>
              </v-row>
              <!-- Changes on this house -->
              <v-row>
                <v-col cols="12" class="pa-1">
                  <countHowz :entity="'eign'" :encrid="eign_encrid" />
                </v-col>
              </v-row>
              <!-- Rebookings for this owner -->
              <v-row>
                <v-col cols="12" class="pa-1">
                  <v-card>
                    <v-card-title>Rebookings ({{ eign.numberOfRebookings }})</v-card-title>
                    <div style="cursor:default" class="flex px-4 pt-2 pb-4">
                      <div class="column">By guest: <span class="col-value">{{ eign.numberOfRebookingsGuest }}</span>
                      </div>
                      <div class="column">By host: <span class="col-value">{{ eign.numberOfRebookingsHost }}</span>
                      </div>
                      <div class="column">By Villa for You: <span class="col-value">{{ eign.numberOfRebookingsVfy
                          }}</span></div>
                      <div class="column">By Force Majeure: <span class="col-value">{{
                        eign.numberOfRebookingsForceMajeure
                          }}</span></div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <!-- Cancellations for this owner -->
              <v-row>
                <v-col cols="12" class="pa-1">
                  <v-card>
                    <v-card-title>Cancellations ({{ eign.numberOfCancellations }})</v-card-title>
                    <div style="cursor:default" class="flex px-4 pt-2 pb-4">
                      <div class="column">By guest: <span class="col-value">{{ eign.numberOfCancellationsGuest }}</span>
                      </div>
                      <div class="column">By host: <span class="col-value">{{ eign.numberOfCancellationsHost }}</span>
                      </div>
                      <div class="column">By Villa for You: <span class="col-value">{{ eign.numberOfCancellationsVfy
                          }}</span>
                      </div>
                      <div class="column">By Force Majeure: <span class="col-value">{{
                        eign.numberOfCancellationsForceMajeure
                          }}</span></div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
        <!-- Accommodations -->
        <v-row class="px-2 mb-4" v-if="eign.lHasAccess">
          <v-col cols="12">
            <v-card fluid>
              <v-card-title>Accommodations ({{ items.length }})</v-card-title>
              <v-btn class="primary ml-4 mb-2" small @click="addHuis">Add accommodation</v-btn>
              <addHuis ref="addHuis"></addHuis>
              <acco_table :items="items" :fixedHeader="false" class="pb-4" searchfield />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <select_ambassador ref="ambassador" @actionClick="updateAmbassador" />
      <m_attm ref="m_attm"></m_attm>
      <nott ref="nott"></nott>
      <rmEign ref="rmEign"></rmEign>
      <updEignPassword ref="updEignPassword"></updEignPassword>
      <billingPDF ref="billingPDF"></billingPDF>
      <downloadbillings ref="downloadbillings" :eign_encrid="eign_encrid" :eign_email="eign.eign_email" :items="items" :eign_code="eign.eign_code"></downloadbillings>
      <eign_invite ref="eign_invite" :eign_encrid="eign_encrid" :eign_email="eign.eign_email"></eign_invite>
      <eignHostEmails ref="eignHostEmails"></eignHostEmails>
    </v-main>
  </v-app>
</template>

<script>
import { bus } from "../../main";
import btn_audit from "@/components/ui/buttons/btn_audit.vue";
import nott from "@/components/nott.vue";
import m_attm from "@/components/m_attm.vue";
import select_ambassador from "@/components/ui/selectors/select_ambassador.vue";
import eign_hokl from '@/components/eign/cards/complaints.vue';
import eign_invite from '@/components/eign/cards/sendInvite.vue';
import acco_table from '@/components/huis/tables/searchHuisTable.vue';
import countHomb from '@/components/huov/homb/countHomb.vue';
import countHowz from '@/components/huov/howz/countHowz.vue';
import addHuis from "@/views/eign/addHuis.vue";
import rmEign from "@/views/eign/rmEign.vue";
import updEignPassword from "@/views/eign/updEignPassword.vue";
import billingPDF from "@/views/eign/ovrz/pdfBilling1.vue";
import downloadbillings from '@/components/eign/cards/bulkBillings.vue';
import defNavBar from '@/components/ui/navbars/navbar.vue';
import YearTurnover from '@/components/turnover/year_turnover.vue';
import eignHostEmails from "@/views/eign/eignHostEmails.vue";

export default {
  components: {
    btn_audit,
    m_attm,
    nott,
    addHuis,
    rmEign,
    updEignPassword,
    billingPDF,
    downloadbillings,
    eign_hokl,
    acco_table,
    countHomb,
    countHowz,
    select_ambassador,
    defNavBar,
    eign_invite,
    YearTurnover,
    eignHostEmails
  },
  props: ["eign_encrid"],
  data() {
    return {
      autocomplete: null,
      eignCard1Valid: false,
      eignCard2Valid: false,
      eignCard3Valid: false,
      taal_codeKeuzes: [],
      taal_code2Keuzes: [],
      taal_code2: [],
      //aanh_codeKeuzes: [],
      land_codeKeuzes: [],
      tel_typeKeuzes: [],
      ebtc_codeKeuzes: [],
      gebr_codeKeuzes: [],
      eign_id_doc_typeKeuzes: [],
      eign_btw_num_statKeuzes: [],
      eign_sales_comKeuzes: [],
      dat1menu: false,
      dat2menu: false,
      items: [],
      eign: {
        lHasAccess: true,
        turnover: [],
        action_items: [] /* moet pre defined ivm length check */,
      },
      eign_naamRules: [(v) => (v && v.length >= 3) || "A name is required"],
      eign_emailRules: [(v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/.test(v) || "E-mail must be valid",],
    };
  },
  created() {
    bus.$on("closeDialog", (data) => {
      console.log(data);
      if (data === 'reload' || data === 'attm_m_attm') {
        this.getEign();
      }
    });
    bus.$on("addNote", (data) => {
      console.log(data);
      this.eign.nott_aant += data;
    });
  },
  mounted() {
    /* eslint-disable no-undef */
    const initAutocomplete = () => {
      if (typeof google !== 'undefined' && typeof google.maps !== 'undefined' && typeof google.maps.places !== 'undefined') {
        const inputElement = this.$refs.autocomplete.$el.querySelector('input');

        this.autocomplete = new google.maps.places.Autocomplete(
          inputElement,
          {
            types: ['geocode'],
            fields: ['address_components', 'geometry', 'name', 'formatted_address']
          }
        );

        // Remove Google's placeholder
        inputElement.setAttribute('placeholder', '');
        inputElement.placeholder = '';
        // Prevent Google from re-adding placeholder
        const observer = new MutationObserver(() => {
          if (inputElement.getAttribute('placeholder')) {
            inputElement.setAttribute('placeholder', '');
            inputElement.placeholder = '';
          }
        });
        observer.observe(inputElement, { attributes: true, attributeFilter: ['placeholder'] });
        setTimeout(() => {
          inputElement.setAttribute('placeholder', '');
          inputElement.placeholder = '';
          inputElement.setAttribute('autocomplete', 'new-password');
        }, 100);

        // Handle Enter key to select first suggestion if none selected
        inputElement.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            const pacContainer = document.querySelector('.pac-container');
            if (pacContainer && pacContainer.offsetParent !== null) {
              const activeItem = pacContainer.querySelector('.pac-item-selected');
              if (!activeItem) {
                e.preventDefault();
                const downEvent = new KeyboardEvent('keydown', { key: 'ArrowDown', code: 'ArrowDown', keyCode: 40, which: 40, bubbles: true });
                e.target.dispatchEvent(downEvent);
                setTimeout(() => {
                  const enterEvent = new KeyboardEvent('keydown', { key: 'Enter', code: 'Enter', keyCode: 13, which: 13, bubbles: true });
                  e.target.dispatchEvent(enterEvent);
                }, 50);
              }
            }
          }
        });

        // Always set only street + house number in address field, regardless of suggestion
        this.autocomplete.addListener('place_changed', () => {
          const place = this.autocomplete.getPlace();
          if (!place.address_components) return;
          let streetNumber = '', route = '', postalCode = '', postalCodeSuffix = '', city = '', countryCode = '';
          place.address_components.forEach(component => {
            const types = component.types;
            if (types.includes('street_number')) streetNumber = component.long_name;
            if (types.includes('route')) route = component.long_name;
            if (types.includes('postal_code')) postalCode = component.long_name;
            if (types.includes('postal_code_prefix') && !postalCode) postalCode = component.long_name;
            if (types.includes('postal_code_suffix')) postalCodeSuffix = component.long_name;
            if (types.includes('locality')) city = component.long_name;
            if (types.includes('country')) countryCode = component.short_name;
          });
          // Compose address as street + house number only
          let addressValue = '';
          if (route && streetNumber) {
            addressValue = route + ' ' + streetNumber;
          } else if (route) {
            addressValue = route;
          } else if (streetNumber) {
            addressValue = streetNumber;
          }
          addressValue = addressValue.trim();
          this.$set(this.eign, 'eign_adres', addressValue);
          // Force the input value as well, to override any Google override
          const inputElement = this.$refs.autocomplete.$el.querySelector('input');
          if (inputElement && inputElement.value !== addressValue) {
            inputElement.value = addressValue;
          }
          if (postalCode) {
            let fullPostalCode = postalCode.replace(/\s+/g, '');
            if (postalCodeSuffix) fullPostalCode += postalCodeSuffix.replace(/\s+/g, '');
            this.$set(this.eign, 'eign_postcode', fullPostalCode);
          }
          if (city) this.$set(this.eign, 'eign_plaats', city);
          if (countryCode) {
            const matchingCountry = this.land_codeKeuzes.find(land => land.land_code === countryCode);
            if (matchingCountry) this.$set(this.eign, 'land_code', countryCode);
          }
          if (place.geometry && place.geometry.location) {
            this.$set(this.eign, 'eign_latitude', place.geometry.location.lat().toString());
            this.$set(this.eign, 'eign_longitude', place.geometry.location.lng().toString());
          }
        });
      } else {
        // Retry after a short delay if Google Maps hasn't loaded yet
        setTimeout(initAutocomplete, 100);
      }
    };
    /* eslint-enable no-undef */

    initAutocomplete();
    this.getEign();
  },
  methods: {
    getEign() {
      this.$axios.post("ares/json/ares/eign/getEign.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getEign",
        },
        getEign: {
          eign_encrid: this.eign_encrid,
        },
      }).then((res) => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
          // console.log(res.data.getEign);
          this.eign = res.data.getEign;

          if (!this.eign.lHasAccess) {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: "You don't have access to this host",
              color: "error",
            });
            return;
          }

          console.log('eign data loaded', this.eign.huizen);
          document.title = "Host " + res.data.getEign.eign_code;
          this.items = res.data.getEign.huizen;
          this.taal_codeKeuzes = res.data.getEign.taal_codeKeuzes;
          this.ebtc_codeKeuzes = res.data.getEign.ebtc_codeKeuzes;
          this.gebr_codeKeuzes = res.data.getEign.gebr_codeKeuzes;
          this.eign_id_doc_typeKeuzes = res.data.getEign.eign_id_doc_typeKeuzes;
          this.eign_btw_num_statKeuzes = res.data.getEign.eign_btw_num_statKeuzes;
          this.eign_sales_comKeuzes = res.data.getEign.eign_sales_comKeuzes;
          this.taal_code2Keuzes = res.data.getEign.taal_code2;
          //this.aanh_codeKeuzes = res.data.getEign.aanh_codeKeuzes;
          this.land_codeKeuzes = res.data.getEign.land_codeKeuzes;
          this.taal_code2 = [];
          this.taal_code2Keuzes.forEach(function (element) {
            if (element.selected) {
              this.taal_code2.push(element.taal_code);
            }
          }.bind(this));

          console.log('eign', this.eign);
        }
      });
    },
    getHeaders(parameter) {
      var _headers = [
        { sortable: false },
        { text: "Id", value: "huis_code" },
        { text: "Status", value: "stat_code" },
        { text: "Pers", value: "huis_aantpers_max" },
        { text: "Name", value: "huis_naam" }
      ];
      var _trailingcols = [
        { text: "Role", value: "hsct_rol" },
        { text: "City", value: "huis_plaats" }
      ];
      if (parameter === false) {
        _headers.push.apply(_headers, _trailingcols); // merge arrays
        return _headers
      } else {
        _headers.push({ text: "Tour Operator Id", value: "plan_to_code" }); // extra column
        _headers.push({ text: "Tour Operator Description", value: "plan_to_naam" }); // extra column
        _headers.push.apply(_headers, _trailingcols); // merge arrays
        return _headers;
      }
    },
    saveEignCard1() {
      if (this.$refs.eignCard1.validate()) {
        // console.log('aanh_code', this.eign.aanh_code);
        this.$axios.post("ares/json/ares/eign/saveEignCard1.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveEignCard1",
          },
          saveEignCard1: {
            eign_encrid: this.eign_encrid,
            eign_naam: this.eign.eign_naam,
            eign_bedrijfsnaam: this.eign.eign_bedrijfsnaam,
            taal_code: this.eign.taal_code,
            taal_code2: this.taal_code2,
            eign_voornaam: this.eign.eign_voornaam,
            eign_adres: this.eign.eign_adres,
            eign_postcode: this.eign.eign_postcode,
            eign_plaats: this.eign.eign_plaats,
            land_code: this.eign.land_code,
            eign_latitude: parseFloat(this.eign.eign_latitude),
            eign_longitude: parseFloat(this.eign.eign_longitude),
            eign_tel1_vcs: this.eign.eign_tel1_vcs,
            eign_tel1_oms: this.eign.eign_tel1_oms,
            eign_tel1_whatsapp : this.eign.eign_tel1_whatsapp,
            eign_tel2_vcs: this.eign.eign_tel2_vcs,
            eign_tel2_oms: this.eign.eign_tel2_oms,
            eign_tel2_whatsapp : this.eign.eign_tel2_whatsapp,
            eign_tel3_vcs: this.eign.eign_tel3_vcs,
            eign_tel3_oms: this.eign.eign_tel3_oms,
            eign_tel3_whatsapp : this.eign.eign_tel3_whatsapp,
            eign_email: this.eign.eign_email,
            eign_email_extra: this.eign.eign_email_extra,
            eign_www: this.eign.eign_www,
            eign_newsletter: this.eign.eign_newsletter,
            eign_klnt_newsletter: this.eign.eign_klnt_newsletter,
            eign_geb_dat: this.eign.eign_geb_dat,
          },
        }).then((res) => {
          console.log(JSON.stringify(res.data));
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.saveEignCard1.text,
              color: res.data.saveEignCard1.color,
            });
            if (res.data.saveEignCard1.color !== "error") {
                this.getEign();
            }
          }
        });
      }
    },
    saveEignCard2() {
      if (this.$refs.eignCard2.validate()) {
        this.$axios.post("ares/json/ares/eign/saveEignCard2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveEignCard2",
          },
          saveEignCard2: {
            eign_encrid: this.eign_encrid,
            eign_iban: this.eign.eign_iban,
            eign_bic: this.eign.eign_bic,
            eign_iban_naam: this.eign.eign_iban_naam,
            ebtc_code: this.eign.ebtc_code,
            // eign_id_doc_type: this.eign.eign_id_doc_type,
            // eign_id_doc_code: this.eign.eign_id_doc_code,
            // eign_rechtsvorm: this.eign.eign_rechtsvorm,
            // eign_fiscaal_code: this.eign.eign_fiscaal_code,
            eign_kvk: this.eign.eign_kvk,
            eign_btw_num_stat: this.eign.eign_btw_num_stat,
            eign_btw_num: this.eign.eign_btw_num,
            eign_geb_dat: this.eign.eign_geb_dat,
            eign_geb_plaats: this.eign.eign_geb_plaats,
            eign_land_code_geb: this.eign.eign_land_code_geb,
            eign_sales_com: parseFloat(this.eign.eign_sales_com),
            eign_bank_stop: this.eign.eign_bank_stop
            // land_code_nationaliteit: this.eign.land_code_nationaliteit
          },
        }).then((res) => {
          console.log(JSON.stringify(res.data));
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.saveEignCard2.text,
              color: res.data.saveEignCard2.color,
            });
          }
        });
      }
    },
    saveEignCard3() {
      if (this.$refs.eignCard3.validate()) {
        this.$axios.post("ares/json/ares/eign/saveEignCard3.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveEignCard3",
          },
          saveEignCard3: {
            eign_encrid: this.eign_encrid,
            gebr_code: this.eign.gebr_code
          },
        })
          .then((res) => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.$store.dispatch("setSnackbar", {
                showing: true,
                text: res.data.saveEignCard3.text,
                color: res.data.saveEignCard3.color,
              });
            }
          });
      }
    },
    addHuis() {
      this.$refs.addHuis.open(this.eign.eign_encrid);
    },
    showHosm(eign_encrid) {
      let route = this.$router.resolve({ path: '/task/customer_success/hosm/hosm_overview/eign:' + eign_encrid }); //props: ['huis_encrid'],
      window.open(route.href, '_blank');
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    actionClick(action) {
      console.log('actionClick', action);
      switch (action) {
        case "rmEign":
          this.$refs.rmEign.open(this.eign_encrid);
          break;
        case "updEignPassword":
          this.$refs.updEignPassword.open(this.eign_encrid);
          break;
        case "billingPDF":
          this.$refs.billingPDF.open(this.eign_encrid);
          break;
        case "downloadbillings":
          this.$refs.downloadbillings.open();
          break;
        case 'm_attm':
          this.$refs.m_attm.open('eign', this.eign.eign_code, '', 'eign', this.eign_encrid, 0);
          break;
        case 'nott':
          this.$refs.nott.open("eign", this.eign_encrid, "all");
          break;
        case 'sendInvite':
          this.sendInvite();
          break;
        case "eignHostEmails" :
          this.$refs.eignHostEmails.open(this.eign_encrid);
          break;
        case "hostprofile":
          this.openHostProfile(this.eign_encrid);
          break;
      }
    },
    openHostProfile(eign_encrid) {
      let route = this.$router.resolve({ path: '/eign/hostProfile/' + eign_encrid });
      window.open(route.href, '_blank');
    },
    sendInvite() {
      this.$refs.eign_invite.open();
    },
    loginInfo(eign_encrid) {
      this.$axios.post("ares/json/ares/eign/encryptRowidForLogin.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getEncryptedRowidForLogin",
        },
        getEncryptedRowidForLogin: {
          eign_encrid: eign_encrid,
        },
      }).then((res) => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
          window.open("https://myvilla.villaforyou.com/fromares/" + res.data.getEncryptedRowidForLogin.eign_encrid);
          return
        }
      });
    },
    loginInfoDev(eign_encrid, type) {
      this.$axios.post("ares/json/ares/eign/encryptRowidForLogin.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getEncryptedRowidForLogin",
        },
        getEncryptedRowidForLogin: {
          eign_encrid: eign_encrid,
        },
      }).then((res) => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
          switch (type) {
            case 1:
              window.open("https://localhost:3000/fromares/" + res.data.getEncryptedRowidForLogin.eign_encrid);
              return
            case 2:
              window.open("https://mytestvilla.villaforyou.com/fromares/" + res.data.getEncryptedRowidForLogin.eign_encrid);
              return
          }
        }
      });
    },
    selectAmbassador() {
      this.$refs.ambassador.openSelect(this.eign.eign_code_ambas, this.eign.ambassador);
    },
    updateAmbassador(value, naam) {
      if (value !== this.eign.eign_code_ambas) {
        this.$axios.post("ares/json/ares/eign/saveAmbassador.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveAmbassador",
          },
          saveAmbassador: {
            eign_encrid: this.eign_encrid,
            eign_code_ambas: value,
          },
        })
          .then((res) => {
            if (res.data.error) {
              //console.log(res.data.error);
              this.$store.dispatch("setSnackbar", {
                showing: true,
                text: res.data.error.message,
                color: "warning",
              });
            } else {
              this.$store.dispatch("setSnackbar", {
                showing: true,
                text: res.data.saveAmbassador.text,
                color: res.data.saveAmbassador.color,
              });
              this.eign.eign_code_ambas = value;
              this.eign.ambassador = naam;
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.text-field-style>>>.v-text-field__slot input {
  color: grey;
  font-weight: 300;
  /* 800 being bold so this is less than half bold */
}

.text-grey {
  color: grey !important;
  font-weight: 400 !important;
  /* 800 being bold so this is half bold */
}

.td_markup {
  vertical-align: top;
  border-top: 5px solid transparent;
  font-size: 15px !important;
  /* trick to add padding to a TD element (which is not possible with CSS normally) */
}

.td_markup_img {
  vertical-align: top;
}

.flex {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.column {
  position: inherit;
  width: 20%;
}

.col-value {
  float: right;
  font-weight: bold;
  padding-right: 40px;
}

.audit {
  cursor: pointer;
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  overflow-y: auto;
}
</style>